import request from '@/utils/server'


//   请求列表
export function getBehaviorList(query) {
    return request({
      url: '/behaviorAnalysis/getBehaviorList',
      method: 'get',
      params: query
    })
  }